<template>
    <input
        class="disabled:bg-gray-100"
        :class="{
            'border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full': variant === 'default',
            'appearance-none block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500  rounded-md shadow-sm': variant === 'filter',
            'border-red-500 bg-red-100': hasError,
        }"
        :type="type"
        :value="modelValue"
        :required="required"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
    >
</template>

<script>
    export default {
        props: {
            modelValue: {
                type: [String, Number],
                default: '',
            },
            type: {
                type: String,
                default: 'text',
            },
            required: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'default',
            },
        },

        emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>
